import React from "react";
import { Card, Typography } from "antd";

const { Title } = Typography;

const CourseOverview = ({ course, imageUrl }) => {
  if (!course || !course.title) {
    return <p>Chargement des informations du cours...</p>;
  }

  return (
    <Card title="Aperçu du cours" style={{ borderRadius: 10 }}>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <img
          src={imageUrl}
          alt="Course"
          style={{ width: 300, borderRadius: 10, objectFit: "cover" }}
        />
      </div>

      <Title level={2} style={{ color: "#1890ff" }}>{course.title}</Title>

      <div>
        <h3>Description :</h3>
        <div dangerouslySetInnerHTML={{ __html: course.overview || "Pas de description" }} />

        <h3>Prérequis :</h3>
        <div dangerouslySetInnerHTML={{ __html: course.requirements || "Non spécifié" }} />

        <h3>Objectifs :</h3>
        <div dangerouslySetInnerHTML={{ __html: course.what_you_will_learn || "Non spécifié" }} />
      </div>
    </Card>
  );
};

export default CourseOverview;
